import { Delete, ExitToApp, NoteAdd, Print, Save } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import axios from 'axios';
import React, { Fragment, memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { useNavigate } from 'react-router-dom';
import DialogCancel from '../../../../../components/utils/dialogCancel/dialogCancel';

const CustomerInfo = ({data,setData,postData,setPostData}) => {

const dispatch = useDispatch()
const navigate = useNavigate()
   const [dialogClose, setDialogClose] = useState(false);
 
let totalAmt=0
  totalAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.totalAmt), 0);
  let gstAmt=0
  gstAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.gstAmt), 0);
  let cessAmt=0
  cessAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.cessAmt), 0);

  const totalmrp = data.reduce((accumulator, item) => accumulator + parseFloat(item.mrp1), 0);

let netTotal = 0
// netTotal = parseFloat(totalAmt + gstAmt + cessAmt).toFixed(2)
netTotal = parseFloat(totalAmt + gstAmt ).toFixed(2)
// netTotal = parseFloat(totalAmt + gstAmt ).toFixed(2)
const onClickCancel = () => {
  setDialogClose(false);
};
const onClickExit = () => {
  navigate("/");
};
// console.log(paymentDetails)
const handleExit = () => {
  setDialogClose(true);
};
console.log(totalmrp,"totalAmt");

  const Design = ({ title, value }) => (
    <div className="flex items-center">
      <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
        {title}
      </Typography>
      <Typography variant="h6" textAlign="right" sx={{ fontWeight: 600, width: "100%", padding: 0.5, }}>
        {parseFloat(value).toFixed(2)}
      </Typography>
    </div>
  );

  console.log(postData,'Post Data')
  function handleSubmit(){
    if(postData.wastage_outlet_detail.length === 0){
      dispatch(setSnackbar(true , "error" , "Please fill table"))
    }else{
      axios.post(`/v1/wastage_outlet_master` , postData)
      // axios.post(`/v1/wastage_master` , postData)
      .then((res) => {
        console.log(res);
        setData([])
        dispatch(setSnackbar(true ,"success" , "Bill Saved Successfully"));
      //   setTimeout(()=>{
      //   window.location.reload();
      // },1000)
    })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true , "error" , err.response.data.errors[0].message))
      })
    }
    
  }
  useEffect(() => {
    const totalQty = data.reduce((accumulator, item) => accumulator + parseFloat(item.qty), 0);
    setPostData((prevState)=>({...prevState, amount: Math.round(parseFloat(netTotal)), totalQty: totalQty.toFixed(2),}))
  },[data , netTotal])
  // uid:uom
console.log(Math.round(parseFloat(netTotal)) , 'amount', netTotal, totalAmt , gstAmt , cessAmt, data)
console.log(data,"datacheck");

  return (
    <Fragment>

        <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }}>Total</Typography>
        <div className="flex p-1">
              <Typography 
              textAlign="right" sx={{  paddingRight: 0.4, fontWeight: 600, fontSize: 36, width:'100%'}}          >
                {Math.round(parseFloat(totalmrp)).toFixed(2)}
              </Typography>
            </div>
            <div className="my-2">
          {/* <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }} > Summary </Typography>
          <Design title="Sub Total" value={totalAmt} />
          <Design title="GST Amt" value={gstAmt}/>
          <Design title="Cess" value={cessAmt}/>
          <Design title="Round Off" value={(netTotal - Math.round(netTotal).toFixed(2))}/>
          <Design title="Net Total" value={Math.round(netTotal)}/> */}
        </div>
        <Stack  >
        {/* <Button size="small" sx={{margin:1}} startIcon={<Delete/>} variant="outlined" onClick={()=>setData([])}>Delete</Button>
        <Button size="small" sx={{margin:1}} startIcon={<Print/>} variant="outlined">Print</Button> */}

        <Button size="small" sx={{margin:1}} startIcon={<NoteAdd/>} variant="outlined" onClick={()=>window.location.reload()}>New</Button>
        <Button size="small" sx={{margin:1}} startIcon={<Save/>} variant="outlined" onClick={handleSubmit} >Save</Button>
        <Button size="small" sx={{margin:1}} startIcon={<ExitToApp />} variant="outlined" onClick={handleExit}>Exit</Button>
        </Stack>
        <DialogCancel
        onClickCancel={onClickCancel}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose={setDialogClose}
      />
    </Fragment>
  )
}

export default memo(CustomerInfo)